import isChatroomDisabledByReed from './isChatroomDisabledByReed';

const rules = [
  isChatroomDisabledByReed,
];

const isPersonalVideoCallDisabled = () => rules.some((rule) => rule());

export default isPersonalVideoCallDisabled;
